export const preloadLazy = (Component, timeout = 1000, label = '') => {
	setTimeout(() => {
		// console.log('generic calling', label);
		Component.preload();
	}, timeout);
};
